import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.scss";

import Homepage from "./pages/Homepage/Homepage";
import Login from "./pages/Loginpage/Loginpage";
import Inputpage from "./pages/Inputpage/Inputpage";
import ProfileRegpage from "./pages/ProfileRegpage/ProfileRegpage";
import { useCookies } from "react-cookie";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../features/firebase";
import useAuthStore from "../features/store";
import Bucket from "./components/Bucket/Bucket";
import RegistAccpage from "./pages/RegistAccpage/RegistAccpage";
import Verificationpage from "./pages/Verificationpage/Verificationpage";
import CheckpointDeleteAccpage from "./pages/Checkpointpage/CheckpointDeleteAccpage";
import VerificationFinalpage from "./pages/Verificationpage/VerificationFinalpage";

function App() {
  const [cookies, setCookie] = useCookies(["user"]);
  const user = cookies.user;
  const { userDB, setUserDB } = useAuthStore();
  //
  useEffect(() => {
    const getUserDB = async () => {
      try {
        if (user) {
          const docRef = doc(db, "registered", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserDB(docSnap.data());
          }
        }
      } catch (error) {
        console.log(error);
      }
    };
    getUserDB();
  }, [user, setCookie, setUserDB]);

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@24,300,0,0"
        />
      </Helmet>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage user={user} userDB={userDB} />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/anggota/registrasi-anggota"
            element={<Inputpage user={user} />}
          />
          <Route
            path="/registrasi-profil"
            element={<ProfileRegpage user={user} />}
          />
          <Route
            path="/registrasi-akun"
            element={<RegistAccpage user={user} />}
          />
          <Route
            path="/verifikasi"
            element={<Verificationpage user={user} />}
          />
          <Route
            path="/verifikasi/autentikasi-akhir"
            element={<VerificationFinalpage user={user} />}
          />
          <Route
            path="/checkpoint/hapus-akun"
            element={<CheckpointDeleteAccpage user={user} />}
          />
          <Route path="/bucket" element={<Bucket />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
